import {
  BridgeEvent,
  PermissionStatus,
} from '@unu/ui-enums';

import {
  sendEvent,
} from '@unu/ui-common';

const setContext = context => sendEvent({
  name: BridgeEvent.SendData,
  data: {
    name: BridgeEvent.SetContext,
    data: {
      context,
    },
  },
});

const tag = ({
  args,
} = {}) => sendEvent({
  name: BridgeEvent.SendData,
  data: {
    name: BridgeEvent.InsightsTag,
    data: args,
  },
});

const traceError = ({
  args,
} = {}) => sendEvent({
  name: BridgeEvent.SendData,
  data: {
    name: BridgeEvent.InsightsTraceError,
    data: args,
  },
});

const traceInformation = ({
  args,
} = {}) => sendEvent({
  name: BridgeEvent.SendData,
  data: {
    name: BridgeEvent.InsightsTraceInformation,
    data: args,
  },
});

const traceWarning = ({
  args,
} = {}) => sendEvent({
  name: BridgeEvent.SendData,
  data: {
    name: BridgeEvent.InsightsTraceWarning,
    data: args,
  },
});

export const NativeBridgeInsightsInterface = {
  overrides: {
    permissionStatus: PermissionStatus.Approved,
  },
  factory: () => ({
    setContext,
    tag,
    traceError,
    traceInformation,
    traceWarning,
  }),
}